import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  analyticsPages: [],
  isRefreshAnalyticsPages: true,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setAnalyticsPages(state, action) {
      state.analyticsPages = [...action.payload];
      state.isRefreshAnalyticsPages = false;
    },
    setIsRefreshAnalyticsPages(state, action) {
      state.isRefreshAnalyticsPages = action.payload;
    },
  },
});

export const { setIsRefreshAnalyticsPages, setAnalyticsPages } =
  analyticsSlice.actions;
export default analyticsSlice.reducer;
